<template>
    
    <div class="p-3">
        <h6>Configurações</h6>

        <!--
        <div class="aside-options">
          <div class="clearfix mt-4">
            <small><b>Option 1</b></small>
            <c-switch color="success" label variant="pill" size="sm" class="float-right" checked />
          </div>
          <div>
            <small class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</small>
          </div>
        </div>
        <div class="aside-options">
          <div class="clearfix mt-3">
            <small><b>Option 2</b></small>
            <c-switch color="success" label variant="pill" size="sm" class="float-right" />
          </div>
          <div>
            <small class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</small>
          </div>
        </div>
        <div class="aside-options">
          <div class="clearfix mt-3">
            <small><b>Option 3</b></small>
            <c-switch color="success" label variant="pill" size="sm" class="float-right" disabled defaultChecked/>
          </div>
          <div>
            <small class="text-muted">Disabled option.</small>
          </div>
        </div>
        <div class="aside-options">
          <div class="clearfix mt-3">
            <small><b>Option 4</b></small>
            <c-switch color="success" label variant="pill" size="sm" class="float-right" checked />
          </div>
        </div>
        -->
        <hr>
        <h6></h6>
        <div class="text-uppercase mb-1 mt-4">
          <small><b>Versão do Sistema</b></small>
        </div>        
        <small class="text-muted">SMG v{{ this.$store.state.config.version }}</small><br>
        <small class="text-muted">IP: {{ this.ipAddress }}</small><br>
        
        <div class="text-uppercase mb-1 mt-4">
          <small><b>Licença</b></small>
        </div>        
        <small class="text-muted">{{ this.$store.state.config.companyName }}</small><br>
        <small class="text-muted">{{ this.$store.state.config.companyDoc }}</small><br>
        <small class="text-muted">CID: {{ this.$store.state.config.companyId }}</small><br>
        <small class="text-muted"><font color="white">{{ this.$store.state.ws_url }}</font></small>
        
        <hr>
        <h6>Utilização do Sistema</h6>
        <div class="text-uppercase mb-1 mt-4">
          <small><b>Uso da CPU</b></small>
        </div>
        <b-progress height={} class="progress-xs" variant="info" :value="1200/100"></b-progress>
        <small class="text-muted">12 Processos. 1/1 Core</small>
        <div class="text-uppercase mb-1 mt-2">
          <small><b>Uso da Memória</b></small>
        </div>
        <b-progress height={} class="progress-xs" variant="warning" :value="220/4"></b-progress>
        <small class="text-muted">2.2GB/4GB</small>

        <!--
        <div class="text-uppercase mb-1 mt-2">
          <small><b>Uso do disco 1</b></small>
        </div>
        <b-progress height={} class="progress-xs" variant="danger" :value="65000/1000"></b-progress>
        <small class="text-muted">100MB/10GB</small>
        -->

        <div class="text-uppercase mb-1 mt-2">
          <small><b>Uso do disco</b></small>
        </div>
        <b-progress height={} class="progress-xs" variant="success" :value="5000/250"></b-progress>
        <small class="text-muted">100MB/10GB</small>
      </div>

</template>

<script>
import axios from "axios";

export default {
  name: 'aboutSystem',
  data: function() {
    return {
      ipAddress: ''
    }
  },
  methods: {
    async getIp() {
      axios.get('https://api.ipify.org?format=json')
        .then(response => {
            this.ipAddress = response.data.ip;
        })
        .catch(error => {
            console.log(error);
        });

    }
  },
  mounted: function(){
      this.getIp();
  }
}

</script>
